/* ==========================================================================
   Your Selection — the reward line

   The panel under the configurator listed the item and its price and stopped
   there. The handoff draws more: from $50 the panel says $5 OFF and strikes
   the price pink, from $85 it adds FREE SHIPPING, from $125 the free bag —
   the same ladder the bag shows, read from the same theme settings.

   The subtotal is the bag plus what is selected on the page, before
   discounts, with subscribed units left out — a subscription already carries
   its own saving and cannot also buy a sitewide reward (the drawer counts the
   same way). The $5 is an order-level discount, so the struck price on the
   visible row shows that row's share of it, in proportion.

   The panel is redrawn by the gallery script on every choice, so this watches
   the panel and re-applies itself; its own writes are recognised and skipped
   rather than watched into a loop.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.gioSelectionRewards || {};
  var T1 = (Number(CFG.t1) || 50) * 100;
  var T2 = (Number(CFG.t2) || 85) * 100;
  var T3 = (Number(CFG.t3) || 125) * 100;

  var LABELS = [
    CFG.label1 || '$5 OFF',
    CFG.label2 || '$5 OFF &middot; FREE SHIPPING',
    CFG.label3 || '$5 OFF &middot; FREE SHIPPING &middot; FREE BAG OF COFFEE OR TEA'
  ];
  var NOTES = [
    CFG.note1 || 'Rewards apply sitewide; subscriptions excluded.',
    CFG.note2 || 'Free shipping applies to orders shipping to one address.',
    CFG.note3 || 'Free shipping applies to orders shipping to one address.'
  ];
  var CUT = (Number(CFG.cut) || 5) * 100;

  function host() {
    return document.getElementById('pendingOrder');
  }

  function money(cents) {
    var whole = cents % 100 === 0 && window.gioNoCents;
    var n = (cents / 100).toFixed(whole ? 0 : 2);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parseCents(text) {
    var m = String(text || '').match(/\$\s?([\d,]+(?:\.\d{1,2})?)/);
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : 0;
  }

  /* ---- the bag, counted the drawer's way -------------------------------- */
  var bag = { cents: 0, byVariant: {}, at: 0 };

  function bagState() {
    if (Date.now() - bag.at < 4000) return Promise.resolve(bag);
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cents = 0;
        var byVariant = {};
        (cart.items || []).forEach(function (line) {
          byVariant[line.variant_id] = (byVariant[line.variant_id] || 0) + line.quantity;
          if (line.selling_plan_allocation) return;
          cents += line.original_line_price;
        });
        bag.cents = cents;
        bag.byVariant = byVariant;
        bag.at = Date.now();
        return bag;
      })
      .catch(function () { return bag; });
  }

  /* ---- what the page has selected ---------------------------------------- */
  function selection() {
    var el = host();
    var row = el && el.querySelector('.order-row');
    if (!row) return null;
    var now = row.querySelector('.order-now');
    var note = row.querySelector('.order-sub-note');
    var idField = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var qtyField = document.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
    // Once this script has struck the price, .order-now holds the CUT figure;
    // the full one is kept on the strike, and that is the one to count.
    var ours = row.querySelector('.order-was[data-gio-cut]');
    var cents = ours
      ? Number(ours.getAttribute('data-gio-full')) || 0
      : parseCents(now && now.textContent);
    return {
      row: row,
      cents: cents,
      qty: qty,
      unit: Math.round(cents / qty),
      variantId: idField ? String(idField.value) : '',
      subscribed: !!(note && /subscri/i.test(note.textContent))
    };
  }

  function band(subtotal) {
    if (subtotal >= T3) return 3;
    if (subtotal >= T2) return 2;
    if (subtotal >= T1) return 1;
    return 0;
  }

  var painting = false;
  var missed = false;

  function paint() {
    if (!host()) return;

    bagState().then(function (state) {
      var el2 = host();
      if (!el2) return;

      /* The selection is read HERE, after the bag has answered, not before
         the fetch. Read before, a paint that started while the shopper was
         still choosing (the variant changes several times as flavour,
         packaging and ribbon settle) was applied to a choice that no longer
         existed — which is how a $35 Gift Box already in the bag, with the
         same Gift Box on the page, showed "$5 OFF". */
      var sel = selection();

      /* What the ORDER would come to. The panel keeps showing a configuration
         after it has been added, so the units already sitting in the bag are
         not counted a second time. Only units not yet added are pending. */
      var pending = 0;
      if (sel && !sel.subscribed) {
        var already = (state.byVariant && state.byVariant[sel.variantId]) || 0;
        pending = Math.max(0, sel.qty - already) * sel.unit;
      }
      var eligible = state.cents + pending;
      var b = band(eligible);

      var note = el2.querySelector('.gg-reward-band');
      var wanted = b
        ? '<div class="gg-reward-band-label">' + LABELS[b - 1] + '</div>' +
          '<div class="gg-reward-band-note">' + NOTES[b - 1] + '</div>'
        : '';

      painting = true;

      if (!wanted) {
        if (note) note.remove();
      } else {
        if (!note) {
          note = document.createElement('div');
          note.className = 'gg-reward-band';
          el2.appendChild(note);
        }
        // Compared to what was last written, not to innerHTML: the labels hold
        // &middot; and innerHTML hands back the character, so the two never
        // matched and the band was rewritten on every mutation on the page.
        if (note.__gioWanted !== wanted) { note.innerHTML = wanted; note.__gioWanted = wanted; }
      }

      /* The visible row's share of the $5, struck pink — and taken off again
         when the order no longer earns it. The strike used to be one-way: once
         drawn it stayed, whatever the order came to afterwards. Skipped for a
         subscription, whose price already shows its own saving, and where the
         gallery has drawn its own was-price. */
      var amt = sel && sel.row && sel.row.isConnected && sel.row.querySelector('.order-amt');
      var nowEl = amt && amt.querySelector('.order-now');
      if (nowEl) {
        var ours = amt.querySelector('.order-was[data-gio-cut]');
        var theirs = amt.querySelector('.order-was:not([data-gio-cut])');
        var cut = 0;
        if (!theirs && !sel.subscribed && b && eligible > 0 && sel.cents <= eligible) {
          cut = Math.round(CUT * (sel.cents / eligible));
          if (!(cut > 0 && cut < sel.cents)) cut = 0;
        }

        if (cut) {
          if (!ours) {
            ours = document.createElement('span');
            ours.className = 'order-was';
            ours.setAttribute('data-gio-cut', '1');
            amt.insertBefore(ours, nowEl);
          }
          var full = String(sel.cents);
          if (ours.getAttribute('data-gio-full') !== full) ours.setAttribute('data-gio-full', full);
          var wasText = money(sel.cents);
          if (ours.textContent !== wasText) ours.textContent = wasText;
          var cutText = money(sel.cents - cut);
          if (nowEl.textContent !== cutText) nowEl.textContent = cutText;
          if (!nowEl.classList.contains('is-cut')) nowEl.classList.add('is-cut');
        } else if (ours) {
          var back = money(Number(ours.getAttribute('data-gio-full')) || sel.cents);
          ours.remove();
          if (nowEl.textContent !== back) nowEl.textContent = back;
          if (nowEl.classList.contains('is-cut')) nowEl.classList.remove('is-cut');
        }
      }

      setTimeout(function () {
        painting = false;
        // A redraw by the gallery that landed while this paint was writing was
        // ignored as our own; look once more so it is not lost.
        if (missed) { missed = false; schedule(); }
      }, 0);
    });
  }

  /* ---- keep up with the gallery's redraws -------------------------------- */
  var queued = false;

  function schedule() {
    if (queued || painting) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      paint();
    }, 120);
  }

  function boot() {
    var el = host();
    if (!el) return false;
    paint();
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (records) {
        if (painting) { missed = true; return; }
        // Our own band is the last child; a mutation entirely inside it is ours.
        var foreign = records.some(function (r) {
          var t = r.target;
          return !(t.closest && t.closest('.gg-reward-band'));
        });
        if (foreign) schedule();
      }).observe(el, { childList: true, subtree: true, characterData: true });
    }
    return true;
  }

  if (!boot()) {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  }
})();
